var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7281 6.02786L10.2476 1.88559C9.96305 1.08946 8.83715 1.08946 8.5526 1.88559L7.0721 6.02786H2.36219C1.46973 6.02786 1.12149 7.18698 1.86618 7.67884L5.60048 10.1453L4.16042 14.1745C3.86937 14.9888 4.78235 15.7049 5.50393 15.2283L9.4001 12.6549L13.2963 15.2283C14.0178 15.7049 14.9308 14.9888 14.6398 14.1745L13.1997 10.1453L16.934 7.67884C17.6787 7.18698 17.3305 6.02786 16.438 6.02786H11.7281Z",
    fill: "#E8E8F4",
    stroke: "#E8E8F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarGray);
export default __webpack_public_path__ + "static/media/star_gray.2f534360f128d0c499e41afd377e74dd.svg";
export { ForwardRef as ReactComponent };